import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryBar() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-10 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-secondary-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}